export interface UpdateUser{
 
    userDBId: number;
    publicId: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
    applicationRoles: any[];
    isApplicationRolesDisabled: boolean;
    caseIdNumber: string;
    isCaseIdNumberVisible: boolean;
    provinceId: number;
    isProvinceVisible: boolean;
    branchId: number;
    isBranchVisible: boolean;
    coachId: number;
    isCoachVisible: boolean;
    orgId: string;
    isOrgVisible: boolean;
    cohort: number;
    isCohortVisible: boolean;
    specialPermissions: any[];
    isSpecialPermissionsVisible: boolean;
    recommendedSessions: any[];
    isRecommendedSessionVisible: boolean;
    isParticipant:boolean;
    displayName:string;
    isProvinceDisabled:boolean;
    isOrgDisabled:boolean,
    isCohortDisabled:boolean,
    facilitatorId:number,
    isFacilitatorVisible:boolean,
    isFacilitatorDisabled:boolean,
    participantPrograms:string,
  
}

export function UpdateUserDefaultValues():UpdateUser
{
  return {
    userDBId: 0,
    publicId: '',
    firstName: '',
    lastName: '',
    email: '',
    isActive: false,
    applicationRoles: [],
    isApplicationRolesDisabled: false,
    caseIdNumber: '',
    isCaseIdNumberVisible: false,
    provinceId: 0,
    isProvinceVisible: false,
    branchId: 0,
    isBranchVisible: false,
    coachId: 0,
    isCoachVisible: false,
    orgId: '',
    isOrgVisible: false,
    cohort: 0,
    isCohortVisible: false,
    specialPermissions: [],
    isSpecialPermissionsVisible: false,
    recommendedSessions: [],
    isRecommendedSessionVisible: false,
    isParticipant: false  ,
    displayName: '' ,
    isProvinceDisabled: false ,
    isOrgDisabled: false ,
    isCohortDisabled: false ,
    facilitatorId: 0 ,
    isFacilitatorVisible: false ,
    isFacilitatorDisabled: false ,
    participantPrograms:'',
  };
}